<div *ngIf="datasource.data ; else spinner" class="map-list">
    <table mat-table [dataSource]="datasource">
        <ng-container matColumnDef="title">
            <th mat-header-cell *matHeaderCellDef>
                Nome
            </th>
            <td mat-cell *matCellDef="let element">
                {{ element.title }}
            </td>
        </ng-container>

        <ng-container matColumnDef="actions">
            <th class="maps-actions" mat-header-cell *matHeaderCellDef>
                Ações
            </th>
            <td class="maps-actions" mat-cell *matCellDef="let element">
                <button mat-icon-button (click)="editMap(element)">
                    <mat-icon>edit</mat-icon>
                </button>
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="fields"></tr>
        <tr mat-row *matRowDef="let row; columns: fields;"></tr>
    </table>

    <mat-paginator [pageSizeOptions]="[10, 20, 50, 100]" showFirstLastButtons
        aria-label="Selecionar quantidade de elementos na página">
    </mat-paginator>


    <button class="alabia-fab" mat-fab (click)="editMap()">
        <mat-icon>add</mat-icon>
    </button>
</div>

<ng-template #spinner>
    <mat-spinner class="alabia-view-spinner"></mat-spinner>
</ng-template>